// GENERATED FILE - DO NOT MODIFY
export enum BonusType {
    Quantity = 1,
    Checkbox = 2,
    Hours = 3,
}

export let nameof = "BonusType";
